import { useEffect, useState } from 'react';
import './UpdateBanner.css';

export default function UpdateBanner() {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    const handler = () => setShowUpdate(true);
    window.addEventListener('sw-update', handler);
    return () => window.removeEventListener('sw-update', handler);
  }, []);

  const handleUpdate = () => {
    window.location.reload();
  };

  if (!showUpdate) return null;

  return (
    <div className="update-banner">
      <span><i className="ti ti-refresh"></i> Új verzió érhető el!</span>
      <button onClick={handleUpdate}>Frissítés</button>
    </div>
  );
}